@defer {
  <div class="login_page">
    <div class="illustration left" [class]="'entry-' + entryPoint">
      <img src="assets/images/login/all-sd.png" alt="Shade Illustration" />
      <img src="assets/images/login/cycl.png" alt="Bike Illustration" />
      <img src="assets/images/login/road.png" alt="Road Illustration" />
    </div>

    <div class="login_card">
      <img src="assets/images/login/techwyse-logo.png" class="logo" alt="TechWyse Logo" />
      
      <div class="quote">
        <img src="assets/images/login/lock.png" class="smiley" alt="Lock Icon" />
        <span>
          <strong>Forgot Password</strong>. Not to worry, Enter your email/phone to receive OTP.
        </span>
      </div>

      <!-- Email Form -->
      @if (!showOtpField() && !showPasswordField()) {
        <form [formGroup]="forgotPasswordForm" (ngSubmit)="sendOtp()">
          <div class="input_group">
            <div class="form-fields" [class]="forgotPasswordForm.get('email')?.valid && forgotPasswordForm.get('email')?.touched && !errorMessage() ? 'input-with-success' : (forgotPasswordForm.get('email')?.invalid && (isEmailTyping() || forgotPasswordForm.get('email')?.touched)) || forgotPasswordForm.get('email')?.errors?.['backendError'] ? 'input-with-error' : ''">
              <input 
                type="text" 
                id="email"
                formControlName="email" 
                placeholder="Email or Phone" 
                [class.is-invalid]="(forgotPasswordForm.get('email')?.invalid && (isEmailTyping() || forgotPasswordForm.get('email')?.touched)) || forgotPasswordForm.get('email')?.errors?.['backendError']"
                [class.is-valid]="forgotPasswordForm.get('email')?.valid && forgotPasswordForm.get('email')?.touched"
                (input)="onEmailInput($event)"
                (focus)="onEmailFocus()"
              />
              @if (forgotPasswordForm.get('email')?.valid && forgotPasswordForm.get('email')?.touched && !errorMessage()) {
                <span class="success-circle"></span>
              }
              @if ((forgotPasswordForm.get('email')?.invalid && (isEmailTyping() || forgotPasswordForm.get('email')?.touched)) || forgotPasswordForm.get('email')?.errors?.['backendError']) {
                <span class="error-circle"></span>
              }
            </div>
          </div>
          <div class="error_wrap">@if ((forgotPasswordForm.get('email')?.touched && forgotPasswordForm.get('email')?.errors) || forgotPasswordForm.get('email')?.errors?.['backendError']) {
            <div class="error_message">
              {{ getErrorMessage('email', forgotPasswordForm) }}
            </div>
          }</div>
          
          <div class="btn_wrap">
            <a routerLink="#/login" class="back-link">Back to Login</a>
            <button type="submit" [disabled]="forgotPasswordForm.invalid || isLoading()">
              @if (!isLoading()) {
                <span>Send OTP</span>
              } @else {
                <span class="loading_spinner"></span>
              }
            </button>
          </div>
        </form>
      }

      <!-- OTP Form -->
      @if (showOtpField() && !showPasswordField()) {
        <form [formGroup]="otpForm" (ngSubmit)="verifyOtp()">
          <div class="input_group">
            <div class="form-fields">
              <div class="otp-input-container">
                @for (i of [0,1,2,3]; track i) {
                  <input 
                    type="text" 
                    [formControlName]="'otp' + (i + 1)" 
                    class="otp-input" 
                    [class.is-invalid]="otpForm.get('otp' + (i + 1))?.errors?.['backendError']"
                    maxlength="1"
                    (input)="onOtpInput($event, i)"
                    (keydown)="onKeyDown($event, i + 1)"
                    (paste)="onOtpPaste($event)"
                  />
                }
              </div>
              @if (otpForm.invalid && otpForm.touched &&!errorMessage()) {
                <div class="validation_error">
                  Please enter all 4 digits
                </div>
              }
            </div>
          </div>
          <div class="error_wrap">@if (errorMessage() && otpForm.get('otp1')?.errors?.['backendError'] )  {
            <div class="error_message">
              {{ errorMessage() }}
            </div>
          }</div>
          <div class="btn_wrap">
            <a routerLink="#/login" class="back-link">Back to Login</a>
            <button type="submit" [disabled]="otpForm.invalid || isLoading()">
              @if (!isLoading()) {
                <span>Verify OTP</span>
              } @else {
                <span class="loading_spinner"></span>
              }
            </button>
          </div>
        </form>
      }

      <!-- New Password Form -->
      @if (showPasswordField()) {
        <form class="new-password-form" [formGroup]="newPasswordForm" (ngSubmit)="resetPassword()">
          <div class="input_group">
            <div class="form-fields" [class]="newPasswordForm.get('password')?.valid && newPasswordForm.get('password')?.touched ? 'input-with-success' : (newPasswordForm.get('password')?.invalid && (isPasswordTyping() || newPasswordForm.get('password')?.touched)) || newPasswordForm.get('password')?.errors?.['backendError'] ? 'input-with-error' : ''">
              <div class="password-input-container">
                <input 
                  [type]="showPassword() ? 'text' : 'password'" 
                  id="password"
                  formControlName="password" 
                  placeholder="Enter new password"
                  [class.is-invalid]="(newPasswordForm.get('password')?.invalid && (isPasswordTyping() || newPasswordForm.get('password')?.touched)) || newPasswordForm.get('password')?.errors?.['backendError']"
                  [class.is-valid]="newPasswordForm.get('password')?.valid && newPasswordForm.get('password')?.touched"
                  (input)="onPasswordInput()"
                  (focus)="onPasswordFocus()"
                />
                <span class="toggle" (click)="togglePasswordVisibility()">
                  {{ showPassword() ? 'Hide' : 'Show' }}
                </span>
              </div>
              @if (newPasswordForm.get('password')?.valid && newPasswordForm.get('password')?.touched) {
                <span class="success-circle"></span>
              }
              @if ((newPasswordForm.get('password')?.invalid && (isPasswordTyping() || newPasswordForm.get('password')?.touched)) || newPasswordForm.get('password')?.errors?.['backendError']) {
                <span class="error-circle"></span>
              }
              @if ((newPasswordForm.get('password')?.touched && newPasswordForm.get('password')?.errors)) {
                <div class="validation_error nw_pss_err" *ngIf="!errorMessage()">
                  {{ getErrorMessage('password', newPasswordForm) }}
                </div>
              }
            </div>
          </div>
          

          <div class="input_group">
            <div class="form-fields" [class]="newPasswordForm.get('confirmPassword')?.valid && newPasswordForm.get('confirmPassword')?.touched && !newPasswordForm.errors?.['passwordMismatch'] ? 'input-with-success' : ((newPasswordForm.get('confirmPassword')?.invalid && (isConfirmPasswordTyping() || newPasswordForm.get('confirmPassword')?.touched)) || (newPasswordForm.errors?.['passwordMismatch'] && newPasswordForm.get('confirmPassword')?.touched)) ? 'input-with-error' : ''">
              <div class="password-input-container">
                <input 
                  [type]="showConfirmPassword() ? 'text' : 'password'" 
                  id="confirmPassword"
                  formControlName="confirmPassword" 
                  placeholder="Confirm new password"
                  [class.is-invalid]="((newPasswordForm.get('confirmPassword')?.invalid && (isConfirmPasswordTyping() || newPasswordForm.get('confirmPassword')?.touched)) || (newPasswordForm.errors?.['passwordMismatch'] && newPasswordForm.get('confirmPassword')?.touched))"
                  [class.is-valid]="newPasswordForm.get('confirmPassword')?.valid && newPasswordForm.get('confirmPassword')?.touched && !newPasswordForm.errors?.['passwordMismatch']"
                  (input)="onConfirmPasswordInput()"
                  (focus)="onConfirmPasswordFocus()"
                />
                <span class="toggle" (click)="toggleConfirmPasswordVisibility()">
                  {{ showConfirmPassword() ? 'Hide' : 'Show' }}
                </span>
              </div>
              @if (newPasswordForm.get('confirmPassword')?.valid && newPasswordForm.get('confirmPassword')?.touched && !newPasswordForm.errors?.['passwordMismatch']) {
                <span class="success-circle"></span>
              }
              @if (((newPasswordForm.get('confirmPassword')?.invalid && (isConfirmPasswordTyping() || newPasswordForm.get('confirmPassword')?.touched)) || (newPasswordForm.errors?.['passwordMismatch'] && newPasswordForm.get('confirmPassword')?.touched))) {
                <span class="error-circle"></span>
              }
              @if (((newPasswordForm.get('confirmPassword')?.touched && newPasswordForm.get('confirmPassword')?.errors) || (newPasswordForm.errors?.['passwordMismatch'] && newPasswordForm.get('confirmPassword')?.touched))) {
                <div class="validation_error" *ngIf="!errorMessage()">
                  {{ getErrorMessage('confirmPassword', newPasswordForm) }}
                </div>
              }
            </div>
          </div>
          <div class="error_wrap">@if (newPasswordForm.get('confirmPassword')?.errors?.['backendError'])  {
            <div class="error_message">
              {{ errorMessage() }}
            </div>
          }</div>
          <div class="btn_wrap">
            <a routerLink="#/login" class="back-link">Back to Login</a>
            <button type="submit" [disabled]="newPasswordForm.invalid || isLoading()">
              @if (!isLoading()) {
                <span>Reset Password</span>
              } @else {
                <span class="loading_spinner"></span>
              }
            </button>
          </div>
        </form>
      }

      <img src="assets/images/login/workluge-logo.png" class="footer_logo" alt="WorkLuge Logo" />
    </div>

    <div class="illustration right">
      <img src="assets/images/login/str-grp.png" alt="Star Illustration" />
      <img src="assets/images/login/moon.png" alt="Moon Illustration" />
    </div>
  </div>
  <footer>© 2000–{{currentYear}} Licenced Copyright by TechWyse. All rights reserved.</footer>
}




